import { render, staticRenderFns } from "./terms.vue?vue&type=template&id=5f781494&scoped=true&"
var script = {}
import style0 from "./terms.vue?vue&type=style&index=0&id=5f781494&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f781494",
  null
  
)

export default component.exports